

export const jumpMixins = {
    methods: {
        toLogin() {
            this.$router.push({name: 'login', query: {backUrl:'/user'}});

            // if(this.$route.name == 'login' || this.$route.name == 'find' || this.$route.name == 'register'){
            //     this.$router.push({name: 'login'})
            // }else if(this.$route.query.backUrl){
            //     this.$router.push({name: 'login', query: {backUrl:this.$route.query.backUrl}});
            // }else{
            //     this.$router.push({ name: "login", query: { backUrl: window.document.location.pathname + window.document.location.search } });
            // }
        },
        toRegister() {
            this.$router.push({name: 'register', query: {backUrl:'/user'}});

            // if(this.$route.name == 'login' || this.$route.name == 'find' || this.$route.name == 'register'){
            //     this.$router.push({name: 'register'})
            // }else if(this.$route.query.backUrl){
            //     this.$router.push({name: 'register', query: {backUrl:this.$route.query.backUrl}});
            // }else{
            //     this.$router.push({ name: "register", query: { backUrl: window.document.location.pathname + window.document.location.search } });
            // }
        },
        toCenter() {
            this.$router.push("/user")
        },
    }
}